import { VASRestService } from "../api/vas-rest";
import { Observable } from "rxjs/Observable";
import { Subject } from "rxjs/Subject";
import { BehaviorSubject } from "rxjs/BehaviorSubject";
import { ISchedulable } from "../scheduler/schedulable.interface";
import { OfflineError, OnlineNotAuthenticatedError } from "../../error/errors";
import { Session } from "../../business-objects/session/session.model";
import { OperationSequence } from "./operation-sequence";
import { ChangeQItem } from "./item";
import { VasAppFacade } from "../../../vas/services/vas-app-facade.service";
import { ChangeLogService } from "../change-log/changelog.service";

export class SyncUpService implements ISchedulable {

    static readonly CLASS: string = "SyncUpService";
    protected _active: boolean = false;
    active$: BehaviorSubject<boolean> = new BehaviorSubject(false);
    logToConsole: boolean = false;

    protected session: Session;

    error$ = new Subject<Error>();

    protected _syncRequestInterval;

    constructor(
        protected appFacade: VasAppFacade,
        protected restService: VASRestService
    ) {

        this.appFacade.session.getSession().subscribe(session => this.session = session);
    }

    sync(force: boolean = false, changeQItems?: Array<ChangeQItem>): Promise<any> {

        if (force) {
            this.stop();
        }

        if (this.active) {
            return Promise.reject(Error("Service is already running"));
        }

        if (!this.isOnlineAndAuthenticated()) {
            return Promise.reject(Error("Offline"));
        }

        this.start();

        return new Promise((resolve, reject) => {
            this.newSyncUpOperation().sync(changeQItems).toPromise().then(
                result => {
                    this.stop();
                    resolve(result);
                },
                error => {
                    this.stop();
                    reject(error);
                }
            );
        });
    }

    protected newSyncUpOperation(): OperationSequence {
        return new OperationSequence(this.appFacade, this.restService);
    }

    abort(): void {
        this.logToConsole && console.warn("ABORTING");
        this.stop();
    }

    start(): void {
        console.log("sync up start()");
        this.active = true;
    }

    stop(): void {
        console.log("sync up stop()");
        this.active = false;
    }

    run(): Promise<any> {
        return this.sync();
    }

    set active(value: boolean) {
        this._active = value;
        this.active$.next(value);
    }

    get active(): boolean {
        return this._active;
    }

    get isChangesQueueProcessing(): boolean {
        return ChangeLogService.getInstance().isChangesQueueProcessing;
    }

    isBusy(): boolean {
        return this._active;
    }

    syncUpItem(item: ChangeQItem): Promise<any> {
        this.logToConsole && console.log("syncUpItem(%s)", item.id, item);
        return this.sync(false, [item]);
    }

    syncRequest(): void {
        console.log("sync request. is active: %s", this.active);
        clearInterval(this._syncRequestInterval);
        this._syncRequestInterval = setTimeout(() => {
            if (this.active || this.isChangesQueueProcessing) {
                return;
            }
            console.log("calling sync");

            this.sync();
        }, 1000);
    }

    protected error(message): void {
        this.error$.next(new Error(message));
    }

    getSchedulerId(): string {
        return SyncUpService.CLASS;
    }

    protected isOnline(): boolean {
        return this.session.getNetworkStatus().isOnline();
    }

    protected isOnlineAndAuthenticated(): boolean {

        if (!this.session) {
            return new OfflineError("session no available");
        } else if (!this.session.getNetworkStatus().isOnline()) {
            return new OfflineError("not online");
        } else if (!this.session.getNetworkStatus().isAuthenticated()) {
            return new OnlineNotAuthenticatedError("online but not authenticated");
        }
        return true;
    }
}



// WEBPACK FOOTER //
// ./src/core/services/sync-up/sync-up.service.ts